import { Component, Input } from '@angular/core';

@Component({
  selector: 'split-text',
  templateUrl: './split-text.component.html',
  styleUrls: ['./split-text.component.scss']
})
export class SplitTextComponent {
  @Input() public title!: string;
  @Input() public subtitle!: string;

  @Input() public theme: string = 'primary';
  @Input() public position: 'center'|'left' = 'left';
}
